import PaymentServiceList from './PaymentServiceList';
import PaymentServiceShow from './PaymentServiceShow';

export default {
  list: PaymentServiceList,
  show: PaymentServiceShow,
};
